<template>
  <div v-if="isHcpView">
    <div class="gridlist-container">
      <mu-grid-list class="article">
        <mu-grid-tile v-if="isLoading" class="pointer" v-for="post, index in dummy" :key="`post-${index}`">
        </mu-grid-tile>
        <mu-grid-tile v-if="!isLoading" class="pointer" v-for="post, index in posts" :key="`post-${index}`" @click.native="goToModule(post.post_slug)">
          <img :src="post.post_video_thumb" />
          <span slot="title">{{post.post_title}}</span>
          <!--<span slot="subTitle">
            {{post.post_video_desc}}
          </span>-->
        </mu-grid-tile>
      </mu-grid-list>
    </div>
  </div>
</template>
<script>
  import HCPMixin from '../../mixins/HCPMixin';
  import hcpApi from '../../api/Hcp';
  export default {
    mixins: [
      HCPMixin,
    ],
    name: 'hcp-slider-modules',
    data() {
      return {
        posts: [],
        isLoading: true,
      }
    },
    methods: {
      goToModule(slug) {
        let self = this;
        self.$router.push({
          name: 'HcpArticle',
          dummy: 8,
          params: {
            slug: slug
          }
        })
      },
      getFeaturedCorePosts() {
        let self = this;
        self.isLoading = true;
        if(self.isHcpView) {
          hcpApi.getFeaturedCoreModules().then(response => {
            self.posts = response.data;
            self.isLoading = false;
          });
        }
      },
      listen() {
        let self = this;
        self.$EventBus.$on('onProgramSwitchHCP', () => {
          self.getFeaturedCorePosts();
        });
      },
      initMounted() {
        let self = this;
        self.getFeaturedCorePosts();
        self.listen();
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  .gridlist-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: -24px;
    margin-bottom: 24px;
    .article {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      > div {
        width: 300px!important;
        height: 240px!important;
      }
      .mu-grid-tile {
        width: 296px;
        background-color: #D2D2D2;
      }
      .mu-grid-tile-titlebar {
        height: 68px;
      }
      .mu-grid-tile-title-container {
        margin: 0 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SliderModules.vue?099ec8d9